import { render } from "./OpenedAccounting.vue?vue&type=template&id=e8f31910"
import script from "./OpenedAccounting.vue?vue&type=script&lang=js"
export * from "./OpenedAccounting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__